import { render, staticRenderFns } from "./PreviewBanner.vue?vue&type=template&id=b4d65276&scoped=true"
import script from "./PreviewBanner.vue?vue&type=script&lang=js"
export * from "./PreviewBanner.vue?vue&type=script&lang=js"
import style0 from "./PreviewBanner.vue?vue&type=style&index=0&id=b4d65276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d65276",
  null
  
)

export default component.exports